var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareIconBlackFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0052 9.54975C5.91166 9.54975 2.71078 14.623 2.70801 19.9498V20.6128C5.00846 17.8415 8.86498 16.1527 12.0052 16.1527V19.6486C12.0053 20.1558 12.2952 20.6184 12.7517 20.8396C13.2082 21.0608 13.7509 21.0017 14.1491 20.6875L21.6236 13.8528C21.9309 13.6106 22.1103 13.2409 22.1103 12.8496C22.1103 12.4583 21.9309 12.0886 21.6236 11.8464L14.1491 5.01167C13.7509 4.69744 13.2082 4.63837 12.7517 4.85957C12.2952 5.08077 12.0053 5.54334 12.0052 6.05058V9.54975Z",
    fill: "#1F1F23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIconBlackFill);
export default __webpack_public_path__ + "static/media/shareIconBlackFill.b3d49255b01ec651d049cdbe132b8a62.svg";
export { ForwardRef as ReactComponent };